import selection2023Png from '../../static/YearMiddleReport2025/report/selection2023.png'
import selection2024Png from '../../static/YearMiddleReport2025/report/selection2024.png'
import selection2025Png from '../../static/YearMiddleReport2025/report/selection2025.png'

export const yearMiddle2025 = [
  {
    coverImage: selection2025Png,
    url: 'https://mp.weixin.qq.com/s/z-I2fXFZFSdtk5G3_QYFZw',
    isRoute: false,
    title: '2025高标仓市场报告',
  },
  {
    coverImage: selection2024Png,
    url: '/rlb/YearMiddleReport2024/1',
    isRoute: true,
    title: '2024高标仓市场报告',
  },
  {
    coverImage: selection2023Png,
    url: '/rlb/YearEndReport/0',
    isRoute: true,
    title: '2023高标仓市场报告',
  },
]
